import styled from "styled-components";

const ConversationContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1%;
  padding: 1%;
  width: 100%;
`;

export default ConversationContent;
